import fetchServer from "../fetchServer";

/**
 * PATCH /payment/v1/setting/admin
 * Partial update. `minimumWithdrawal`, `minimumWalletBalance`, and
 * `withdrawalProcessing` replace the whole map when sent.
 * Withdrawal fee: `withdrawalFeeMethod` Fixed|Percentage. Fixed uses
 * `withdrawalFee`. Percentage uses `withdrawalFeePercentage` (0–100) and
 * `withdrawalFeeCap` (both must be > 0).
 */
export default async function updateAdminSettings(data) {
  let result = {
    return: 0,
    msg: "Something went wrong updating payment settings",
  };

  try {
    const res = await fetchServer({
      method: "PATCH",
      url: "/payment/v1/setting/admin",
      data,
    });

    if (res?.data && !res?.data?.error) {
      result = { return: 1, msg: "Successful", data: res?.data?.data };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    } else if (res?.msg) {
      result.msg = res.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
